import React, { useState } from 'react';
interface TabViewProps {
  tabs: {
    label: string;
    content: ReactNode;
  }[];
}
export function TabView({
  tabs
}: TabViewProps) {
  const [activeTab, setActiveTab] = useState(0);
  return <div data-id="element-369">
      <div className="border-b border-gray-200" data-id="element-370">
        <div className="flex -mb-px" data-id="element-371">
          {tabs.map((tab, index) => <button key={index} className={`py-2 px-4 text-sm font-medium ${activeTab === index ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab(index)} data-id="element-372">
              {tab.label}
            </button>)}
        </div>
      </div>
      <div className="pt-4" data-id="element-373">{tabs[activeTab].content}</div>
    </div>;
}